'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _common = require('../common');

var _constants = require('../../../src/constants');

var _utils = require('../../utils');

var _util = require('../../utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var toKey = _utils.FormattingUtils.toKey,
    truncate = _utils.FormattingUtils.truncate;
var ACTIVITY_FILE_NAME_TRUNCATE_LENGTH = _constants.AppConstants.ACTIVITY_FILE_NAME_TRUNCATE_LENGTH;
var CaseSmsMediaItem = (_dec = (0, _mobxReact.inject)('SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseSmsMediaItem, _Component);

  function CaseSmsMediaItem() {
    _classCallCheck(this, CaseSmsMediaItem);

    return _possibleConstructorReturn(this, (CaseSmsMediaItem.__proto__ || Object.getPrototypeOf(CaseSmsMediaItem)).apply(this, arguments));
  }

  _createClass(CaseSmsMediaItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          SessionStore = _props.SessionStore,
          _props$mediaItem = _props.mediaItem,
          file = _props$mediaItem.file,
          download_url = _props$mediaItem.download_url,
          filename = truncate((0, _util.getFilename)(file), ACTIVITY_FILE_NAME_TRUNCATE_LENGTH),
          url = SessionStore.addAuthenticationToUrl('' + download_url + toKey({ dl: 0 }));


      return _react2.default.createElement(
        _Button2.default,
        { bsStyle: 'link', target: '_blank', rel: 'noopener noreferrer', href: url },
        _react2.default.createElement(_common.Icon, { type: 'download' }),
        filename
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseSmsMediaItem;
}(_react.Component), _class2.propTypes = {
  mediaItem: _propTypes2.default.object.isRequired,
  onClick: _propTypes2.default.func,
  SessionStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class);
var _default = CaseSmsMediaItem;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(toKey, 'toKey', '/app/src/components/common-activities/CaseSmsMediaItem.js');
  reactHotLoader.register(truncate, 'truncate', '/app/src/components/common-activities/CaseSmsMediaItem.js');
  reactHotLoader.register(ACTIVITY_FILE_NAME_TRUNCATE_LENGTH, 'ACTIVITY_FILE_NAME_TRUNCATE_LENGTH', '/app/src/components/common-activities/CaseSmsMediaItem.js');
  reactHotLoader.register(CaseSmsMediaItem, 'CaseSmsMediaItem', '/app/src/components/common-activities/CaseSmsMediaItem.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/CaseSmsMediaItem.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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